<!--<app-loading-component *ngIf="isShowLoadingComponent"></app-loading-component>-->
<div id="guide">
  <div id="guideImageWrap">
    <img src="{{assetsRoute}}/picture/courselearning/Mindy_new.png" alt="" class="guideImage" *ngIf="course.name!='团队课程'&&course.name!='沟通课程'&&course.name!='协作课程'&&course.name!='组织与计划课程'&&course.name!='影响力课程'&&course.name!='领导力启程'&&course.name!='驱动变革课程'&&course.name!='影响力专业版课程'">
    <img src="{{assetsRoute}}/picture/courselearning/Alex.png" alt="" class="guideImage" *ngIf="course.name=='团队课程'||course.name=='解决冲突课程'">
    <img src="{{assetsRoute}}/picture/courselearning/Rita.png" alt="" class="guideImage" *ngIf="course.name=='沟通课程'||course.name=='领导力启程'">
    <img src="{{assetsRoute}}/picture/courselearning/Mike.png" alt="" class="guideImage" *ngIf="course.name=='协作课程'">
    <img src="{{assetsRoute}}/picture/courselearning/lilith.png" alt="" class="guideImage" *ngIf="course.name=='组织与计划课程'">
    <img src="{{assetsRoute}}/picture/courselearning/Diana.png" alt="" class="guideImage" *ngIf="course.name=='影响力课程'||course.name=='驱动变革课程'||course.name=='影响力专业版课程'">
  </div>
  <div id="guideText" class="fontSize16 lineHeight24">
    <!-- 没有完成课程  -->
    <span *ngIf="lesson.hasMultiLesson && videoIndex < lesson.externalId.length - 1">{{lesson.videoTransitions[videoIndex]}}</span>
    <span *ngIf="questionsGroup && questionsGroup.length > questionIndex">{{transitionText}}</span>
    <!-- 完成本次课程 -->
    <span *ngIf=" (course.lessons.length - 1) > lessonIndex && ((!questionsGroup && (lesson.hasMultiLesson && lesson.externalId.length - 1 == videoIndex || !lesson.hasMultiLesson)) || (questionsGroup && questionsGroup.length == questionIndex))">你已经完成了本次课程，即将进入下一门课程：<br/><br/></span>
    <!-- 下一课 -->
    <span *ngIf="(course.lessons.length - 1) > lessonIndex && ((!questionsGroup && !course.lessons[lessonIndex+1].hasMultiLesson && lesson.externalId.length - 1 == videoIndex) || (!course.lessons[lessonIndex+1].hasMultiLesson && questionsGroup && questionsGroup.length == questionIndex))" class="fontSize18 lineHeight27">{{course.lessons[lessonIndex+1].nameNoBreak}}</span>
    <span *ngIf="(course.lessons.length - 1) > lessonIndex && ((!questionsGroup && (course.lessons[lessonIndex+1].hasMultiLesson && lesson.externalId.length - 1 == videoIndex)) || (course.lessons[lessonIndex+1].hasMultiLesson && questionsGroup && questionsGroup.length == questionIndex))" class="fontSize18 lineHeight27">{{course.lessons[lessonIndex+1].nameNoBreak[videoIndex]}}</span>
    <!-- 完成所有课程 -->
    <span *ngIf="((!questionsGroup) || (questionsGroup && questionsGroup.length == questionIndex)) && (course.lessons.length - 1) == lessonIndex"  [innerHtml]="chuanjie">
      <!--不能应用于实际的学习就是耍流氓，纸上谈兵不可取。<br/><br/>试试在接下来的情景模拟中，你能怎样活用刚才学到的辅导技巧？-->
    </span>
  </div>
  <div id="guideBtn" class="fontSize18" (click)="guideAnimateOut()" *ngIf="!userType ">
    <span *ngIf="questionsGroup || !questionsGroup && (course.lessons.length - 1) != lessonIndex">准备，开始</span>
    <span *ngIf="!questionsGroup && (course.lessons.length - 1) == lessonIndex && course.name!='沟通课程'&&goPracticeFlag">进入情景模拟</span>
    <span *ngIf="!questionsGroup && (course.lessons.length - 1) == lessonIndex&&course.name=='沟通课程'">课程学习已完成</span>
  </div>
  <div id="guideBtn" class="fontSize18" (click)="guideAnimateOut()" *ngIf="userType ">
    <span *ngIf="lessonIndex == 1">体验结束，点击注册</span>
    <span *ngIf="lessonIndex < 1">准备，开始</span>
  </div>
</div>

<div id="cards" *ngIf="questionsGroup && questionsGroup.length > questionIndex && mode == 1">
  <!-- head  -->
  <div id="head" class="fontSize18">
    <!-- 关闭 -->
    <span class="common-back-btn-sight" style="top:.1rem" id="closeIcon" (click)="close()" [ngClass]="{'color4a4a4a':mode == 2}">×</span>
    <!-- 目前题目 -->
    <span *ngIf="questionsGroup && questionsGroup.length > questionIndex && currentNumber < questions.length + 1" [ngClass]="{'color4a4a4a':mode == 2}">{{currentNumber}} / {{allQuestionsNumber}}</span>
    <!-- 题目类型 -->
    <!--<div class="mulIcon mulIconMode1 fontSize14"-->
         <!--*ngIf="questionsGroup && questionsGroup.length > questionIndex && mode == 1 && currentNumber < questions.length + 1"-->
         <!--[ngClass]="{'mulIconStyle1':questions[currentNumber-1].type == '多选题','mulIconStyle2':questions[currentNumber-1].type == '单选题',-->
                     <!--'mulIconStyle3': questions[currentNumber - 1].type == '输入题'}">-->
        <!--{{questions[currentNumber-1].type}}-->
    <!--</div>-->
  </div>
  <div id="card{{i}}" class="card" *ngFor="let question of questions;let i = index">
    <app-component-scroll-title *ngIf="question.id==1||question.id==200||question.id==30||question.id==89||question.id==129||question.id==160||question.id==78||question.id==173||question.id==183||question.id==223||question.id==278"></app-component-scroll-title>
    <div class="cardFront" id="cardFront{{i}}">
      <div class="cardOptionItemWrap">
        <!--题目-->
        <!--<div class="cardFrontText fontSize16 lineHeight23" [innerHtml]="question.content"></div>-->
        <div class="cardFrontText fontSize16 lineHeight23"><font color="#4CA5D2" *ngIf="questions[i].type=='单选题'"><b>【单选题】</b></font><font color="#E06643" *ngIf="questions[i].type=='多选题'"><b>【多选题】</b></font><span [innerHtml]="question.content"></span></div>
        <div class="indentBtn" *ngIf="question.id==186 || question.id==187||question.id ==88" (click)="showAllContent()"><p>查看剩余文本</p></div>
        <!-- 题目大于8个选项 -->
        <div *ngIf="question.option.length >= 8"
             [ngClass]="{'cardOptionWrapCorrectRow':question.type == '多选题' && (!question.selectable) && question.answer !='' && question.selectedOption == question.answer && question.iconShow,
                       'cardOptionWrapWrongRow':question.type == '多选题' && (!question.selectable) && question.answer !='' && question.selectedOption != question.answer && question.iconShow,
                       'cardOptionWrapNormalRow': question.type == '多选题' && (question.selectable || (!question.selectable && question.answer =='' && question.iconShow))}">
          <div class="cardOptionRowWrap fontSize14" *ngFor="let optionItem of question.option;let j=index;let even=even">
            <div  class="cardOptionRow" *ngIf="even">
              <div class="cardOptionRowItem" (click)="onOptionClick($event, i, j, 0)">
                <div class="optionTextRow">
                  {{question.option[j].content}}
                </div>
                <div class="optionColorRowItem" id="optionColor_{{i}}_{{j}}">
                  <div class="optionTextInnerRow">
                    {{question.option[j].content}}
                  </div>
                </div>
                <div *ngIf="question.type == '单选题'">
                  <img src="{{assetsRoute}}/picture/courselearning/right.png" alt="" class="optionCorrect"
                       *ngIf="(!question.selectable)&&question.selectedOption == question.answer && question.answer !='' && question.option[j].select==true && question.iconShow">
                  <img src="{{assetsRoute}}/picture/courselearning/wrong.png" alt="" class="optionError"
                       *ngIf="(!question.selectable)&&question.selectedOption != question.answer && question.answer !='' && question.option[j].select==true && question.iconShow">
                </div>
              </div>
              <div class="cardOptionRowItem" *ngIf="j < question.option.length - 1" (click)="onOptionClick($event, i, j + 1, 0)">
                <div class="optionTextRow">
                  {{question.option[j + 1].content}}
                </div>
                <div class="optionColorRowItem" id="optionColor_{{i}}_{{j + 1}}">
                  <div class="optionTextInnerRow">
                    {{question.option[j + 1].content}}
                  </div>
                </div>
                <div *ngIf="question.type == '单选题'">
                  <img src="{{assetsRoute}}/picture/courselearning/right.png" alt="" class="optionCorrect"
                       *ngIf="(!question.selectable) && question.selectedOption == question.answer && question.option[j + 1].select==true  && question.answer !=''  && question.iconShow">
                  <img src="{{assetsRoute}}/picture/courselearning/wrong.png" alt="" class="optionError"
                       *ngIf="(!question.selectable) && question.selectedOption != question.answer && question.option[j + 1].select==true  && question.answer !=''  && question.iconShow">
                </div>
              </div>
            </div>
            <div *ngIf="question.type == '多选题'">
              <img src="{{assetsRoute}}/picture/courselearning/right.png" alt="" class="optionWrapCorrect"
                   *ngIf="(!question.selectable) && question.answer !=''  && question.selectedOption == question.answer && question.iconShow">
              <img src="{{assetsRoute}}/picture/courselearning/wrong.png" alt="" class="optionWrapError"
                   *ngIf="(!question.selectable) && question.answer !=''  && question.selectedOption != question.answer && question.iconShow">
            </div>
          </div>
        </div>
        <div *ngIf="question.option.length > 2 && question.option.length < 8 || question.option.length==2 && question.length == 2"
             [ngClass]="{'cardOptionWrapCorrect':question.type=='多选题' && (!question.selectable) && question.answer !='' && question.selectedOption == question.answer && question.iconShow,
                       'cardOptionWrapWrong':question.type=='多选题' && (!question.selectable)  && question.answer !='' && question.selectedOption != question.answer && question.iconShow}">
          <div class="cardOptionItem fontSize14" [ngClass]="{'cardOptionLongItem': question.option.length==2 && question.length == 2}" *ngFor="let optionItem of question.option;let j=index" (click)="onOptionClick($event, i, j, 0)">
            <div class="optionText">
              {{optionItem.content}}
            </div>
            <div class="optionColor" id="optionColor_{{i}}_{{j}}">
              <div class="optionTextInner">
                {{optionItem.content}}
              </div>
            </div>
            <div *ngIf="question.type == '单选题'">
              <img src="{{assetsRoute}}/picture/courselearning/right.png" alt="" class="optionCorrect"
                   *ngIf="(!question.selectable) && question.selectedOption == question.answer  && question.answer !='' && question.option[j].select == true && question.iconShow">
              <img src="{{assetsRoute}}/picture/courselearning/wrong.png" alt="" class="optionError"
                   *ngIf="(!question.selectable) && question.selectedOption != question.answer  && question.answer !='' && question.option[j].select == true && question.iconShow">
            </div>
          </div>
          <div *ngIf="question.type == '多选题'">
            <img src="{{assetsRoute}}/picture/courselearning/right.png" alt="" class="optionCorrect"
                 *ngIf="(!question.selectable) && question.answer !='' && question.selectedOption == question.answer && question.iconShow">
            <img src="{{assetsRoute}}/picture/courselearning/wrong.png" alt="" class="optionError"
                 *ngIf="(!question.selectable) && question.answer !='' && question.selectedOption != question.answer && question.iconShow">
          </div>
        </div>
        <div *ngIf="question.option.length==2 && question.length != 2" class="doubleChoice">
          <div class="doubleChoice_left doubleChoiceLeftCommon fontSize16" (click)="onOptionClick($event, i, 0, 1)">
            <span class="doubleChoiceSpan doubleChoiceSpanBottom">{{question.option[0].content}}</span>
          </div>
          <div class="doubleChoice_right doubleChoiceRightCommon fontSize16" (click)="onOptionClick($event, i, 1, 1)">
            <span class="doubleChoiceSpan doubleChoiceSpanBottom">{{question.option[1].content}}</span>
          </div>
          <div class="doubleChoiceOptionColorLeft doubleChoiceLeftCommon" id="optionColor_{{i}}_0" (click)="onOptionClick($event, i, 0, 1)">
            <div class="optionTextInnerLeft doubleChoiceLeftCommon fontSize16">
              <span class="doubleChoiceSpan doubleChoiceSpanTop">{{question.option[0].content}}</span>
            </div>
          </div>
          <div class="doubleChoiceOptionColorRight doubleChoiceRightCommon" id="optionColor_{{i}}_1" (click)="onOptionClick($event, i, 1, 1)">
            <div class="optionTextInnerRight fontSize16">
              <span class="doubleChoiceSpan doubleChoiceSpanTop">{{question.option[1].content}}</span>
            </div>
          </div>
          <img src="{{assetsRoute}}/picture/courselearning/right.png" alt="" class="optionCorrectLeft"
               *ngIf="(!question.selectable) && question.answer !='' && question.selectedOption == question.answer && question.option[0].select && question.iconShow">
          <img src="{{assetsRoute}}/picture/courselearning/right.png" alt="" class="optionCorrectRight"
               *ngIf="(!question.selectable) && question.answer !='' && question.selectedOption == question.answer && question.option[1].select && question.iconShow">

          <img src="{{assetsRoute}}/picture/courselearning/wrong.png" alt="" class="optionErrorLeft"
               *ngIf="(!question.selectable) && question.answer !='' && question.selectedOption != question.answer && question.option[0].select && question.iconShow">
          <img src="{{assetsRoute}}/picture/courselearning/wrong.png" alt="" class="optionErrorRight"
               *ngIf="(!question.selectable) && question.answer !='' && question.selectedOption != question.answer && question.option[1].select && question.iconShow">
        </div>
        <div *ngIf="question.option.length==0" class="textEnter">
          <textarea *ngIf="question.selectable" id="textEnterChoice" class="textEnterNormal fontSize16 lineHeight23" (blur)="goToTop()" (input)="onTextEnter($event, i)" placeholder="最多可输入300字" maxlength="300"></textarea>
          <p *ngIf="!question.selectable" class="textEnterAfter fontSize16 lineHeight23">{{questions[i].textEnter}}</p>
        </div>
        <!--<div class="cardOptionItemMargin">-->
        <!--</div>-->
      </div>
      <!--<div id="circleBtn{{i}}" class="circleBtn fontSize18" (click)='onCircleBtnClick(i)' [ngClass]="{'circleBtnEnable': question.selected,-->
                                                                                                     <!--'circleBtnDisable':!question.selected,-->
                                                                                                     <!--'circleBtnHalo':question.selected && question.selectable}">      -->
        <div id="circleBtn{{i}}" class="circleBtn fontSize18" (click)='onCircleBtnClick(i)' [ngClass]="{'circleBtnEnable': question.selected,
                                                                                                     'circleBtnDisable':!question.selected}">
       <p *ngIf="course.name != '影响力课程'" class="fontSize16 lineHeight24 normalTxt"> 查看<br/>答案 </p>
       <p *ngIf="course.name == '影响力课程'" class="fontSize16 lineHeight24 normalTxt"> 查看<br/>结果 </p>
      </div>
    </div>
    <div id="cardBack{{i}}" class="cardBack">
      <div class="cardBackTextWrap" *ngIf="question.type!='输入题'">
        <!--<div id="cardBackImage{{i}}" class="cardBackImage">-->
          <!--<img src="{{assetsRoute}}/picture/courselearning/neutral.png" alt="" class="neutralImage" *ngIf="questions[i].answer=='' && questions[i].type != '输入题'">-->
          <!--&lt;!&ndash;<img src="{{assetsRoute}}/picture/courselearning/smile.png" alt="" class="../../{{assetsRoute}}/picture/casepracticeclash/animate-13/images/Image" *ngIf="questions[i].answer!=''&&questions[i].selectedOption == questions[i].answer">&ndash;&gt;-->
          <!--&lt;!&ndash;<img src="{{assetsRoute}}/picture/courselearning/cry.png" alt="" class="errorImage" *ngIf="questions[i].answer!=''&&questions[i].selectedOption != questions[i].answer">&ndash;&gt;-->
        <!--</div>-->
        <div class="cardBackText fontSize21">

          <!-- <span *ngIf="question.selectedOption == question.answer">Bingo,你答对了！</span> -->
          <span style="color: rgb(42,203,166)" *ngIf="questions[i].answer!=''&&question.selectedOption == question.answer">Bingo,你答对了！</span>
          <span style="color: rgb(248,102,120)" *ngIf="questions[i].answer!=''&&question.selectedOption != question.answer">别灰心，继续努力！</span>

        </div>
      </div>
      <div id="cardBackAnswer{{i}}" class="cardBackAnswer fontSize16 lineHeight27">
        <div class="cardBackAnswerPara" *ngIf="questions[i].type != '输入题'">
          <p *ngIf="question.answer != '' && question.selectedOption != question.answer"><span class="green">【正确答案】</span>{{question.answerShow}}</p>
          <p [innerHtml]="question.analysis"></p>
        </div>
        <div class="cardBackAnswerPara" *ngIf="questions[i].answer=='' && questions[i].type=='输入题'">
          <div class="cardFrontText2 fontSize16 lineHeight23" [innerHtml]="question.content"></div>
          <div class="textEnter">
            <p class="textEnterAfter fontSize16 lineHeight23">{{questions[i].textEnter}}</p>
          </div>
        </div>
        <br/>
      </div>
      <div id="circleBtn{{i}}" class="circleBtn fontSize18 circleBtnSpecial" (click)='onCircleBtnClick(i)'>
       <p class="fontSize16 lineHeight24 specialTxt"> 查看<br/>题目 </p>
      </div>
    </div>
  </div>
  <div class="card" id="card{{questions.length}}">
    <div class="cardFront" id="cardFront{{questions.length}}">
      <div class="nextImageWrap">
        <img src="{{assetsRoute}}/picture/courselearning/nextWrap.png" alt="" class="nextImage">
        <div class="cardBackText fontSize21">
            <span>你已经完成所有练习了!</span>
        </div>
        <div id="nextWrap">
          <div id="nextLesson" class="fontSize16"  *ngIf="(course.lessons.length - 1 != lessonIndex) && status && !moreQuestions && !morePreQuestions" (click)="nextLesson()">
              <div *ngIf="!(status==3)">
                <p class="lineHeight21" *ngIf="!course.lessons[lessonIndex+1].hasMultiLesson && status==1 && !enterFromPre||status!=1&&lessonIndex==0">下一课 ： {{course.lessons[lessonIndex+1].nameNoBreak}}</p>
                <p class="lineHeight21" *ngIf="course.lessons[lessonIndex+1].hasMultiLesson && status==1 && !enterFromPre||status!=1&&lessonIndex==0">下一课 ： {{course.lessons[lessonIndex+1].nameNoBreak[0]}}</p>
              </div>
              <div *ngIf="status==3">
                <p class="lineHeight21" *ngIf="!course.lessons[lessonIndex+1].hasMultiLesson && status==1 && !enterFromPre||status!=1&&lessonIndex==0">下一课 ： {{course.lessons[lessonIndex+1].nameNoBreak}}</p>
              </div>
              <p class="lineHeight21" *ngIf="status==1 && (preLength - 1 == questionIndex) && enterFromPre">进入课程视频</p>
              <!-- <span *ngIf="status==1 && (preLength - 1 == questionIndex) ||status!=1&&lessonIndex==0">进入课程视频</span> -->
              <p class="lineHeight21" *ngIf="status!=1&&lessonIndex!=0">课程学习试用完毕！</p>
          </div>
          <div id="nextQuestions" class="nextQuestions fontSize16" *ngIf="questionsGroup && questionsGroup.length > questionIndex && moreQuestions && !morePreQuestions" (click)="nextQuestionNoRepeat()">
              <p class="lineHeight21">下一练习 ： 课后练习{{questionIndex + 2 - preLength}}</p>
          </div>
          <div id="nextPreQuestions" class="nextQuestions fontSize16" *ngIf="questionsGroup && questionsGroup.length > questionIndex && morePreQuestions && !moreQuestions" (click)="nextQuestionNoRepeat()">
              <p class="lineHeight21">下一练习 ： 课前练习{{questionIndex + 2 - preLength}}</p>
          </div>
          <div id="nextSection" class="nextQuestions fontSize16" *ngIf = "questionsGroup && course.lessons.length - 1 == lessonIndex && questionsGroup.length - 1 == questionIndex"  (click)="returnHome()">
              <p class="lineHeight21">返回课程列表</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="preQuestion"  (click)="slide('right')" id="arrowLeft"></div>
  <div class="nextQuestion"  (click)="slide('left')" id="arrowRight"></div>
  <div class="disablePreQuestion" id="arrowLeftGray"></div>
  <div class="disableNextQuestion" id="arrowRightGray"></div>

  <!--<img src="{{assetsRoute}}/picture/courselearning/arrow-left.png" (click)="slide('right')" alt="" id="arrowLeft" class="arrowNormal imgAble">-->
  <!--<img src="{{assetsRoute}}/picture/courselearning/arrow-right.png" (click)="slide('left')" alt="" id="arrowRight" class="arrowNormal imgAble">-->
  <!--<img src="{{assetsRoute}}/picture/courselearning/arrow-right-gray.png" (click)="slide('left')" alt="" id="arrowRightGray" class="arrowGray imgAble">-->
  <!-- <div id="circleBtn{{i}}" class="circleBtn fontSize18" (click)='onCircleBtnClick()' [ngClass]="{'circleBtnEnable': question.selected,
                                                                                                 'circleBtnDisable':!question.selected,
                                                                                                 'circleBtnHalo':question.selected && question.selectable}">
   <p *ngIf="question.selectable || !this.backface[this.currentNumber - 1] " class="fontSize16 lineHeight24"> 查看<br/>答案 </p>
   <p *ngIf="!question.selectable && this.backface[this.currentNumber - 1]" class="fontSize16 lineHeight24"> 查看<br/>题目 </p>
  </div> -->
</div>

<!-- <div id="circleBtnFake" class="fontSize18" *ngIf="questionsGroup && questionsGroup.length > questionIndex && mode == 1">
</div> -->

<!-- <div id="nextLesson" class="fontSize16" (click)="nextLesson()">
    <span *ngIf="status==1||status!=1&&lessonIndex==0">下一课 ： {{course.lessons[lessonIndex+1].name}}</span>
    <span *ngIf="status!=1&&lessonIndex!=0">课程学习试用完毕！</span>
</div>

<div id="nextQuestions" class="fontSize16"  (click)="nextQuestion()">
    下一练习 ： 课后练习{{questionIndex+2}}
</div> -->

<!-- <div id="longModeWrap" *ngIf="questionsGroup&&mode == 2">
    <div class="mulIcon mulIcon2 fontSize14"
         [ngClass]="{'mulIconStyle1':questions[currentNumber-1].type=='多选题','mulIconStyle2':questions[currentNumber-1].type=='单选题'}">
        {{questions[currentNumber-1].type}}
    </div>
    <div class="longModeQuestion fontSize16 lineHeight24">
        {{questions[currentNumber-1].content}}
    </div>
    <div class="longModeQuestionOptionsWrap"
         [ngClass]="{'cardOptionWrapCorrect':questions[currentNumber-1].type=='多选题'&&(!questions[currentNumber-1].selectable)&&questions[currentNumber-1].selectedOption == questions[currentNumber-1].answer,
                     'cardOptionWrapWrong':questions[currentNumber-1].type=='多选题'&&(!questions[currentNumber-1].selectable)&&questions[currentNumber-1].selectedOption != questions[currentNumber-1].answer}">
        <div class="cardOptionItem fontSize14" *ngFor="let optionItem of questions[currentNumber-1].option;let j=index;let even=even" (click)="onOptionClick($event,this.currentNumber-1,j,0)">
            <div class="optionText">
                {{optionItem.content}}
            </div>
            <div class="optionColor" id="optionColorLongMode_{{(this.currentNumber-1)}}_{{j}}"
                [ngClass]="{'optionColorSelected':(!questions[currentNumber-1].selectable)&&questions[currentNumber-1].option[j].select}">
                <div class="optionTextInner">
                    {{optionItem.content}}
                </div>
            </div>
            <div *ngIf="questions[currentNumber-1].type=='单选题'">
                <img src="{{assetsRoute}}/picture/courselearning/right.png" alt="" class="optionCorrect"
                     *ngIf="(!questions[currentNumber-1].selectable)&&questions[currentNumber-1].selectedOption == questions[currentNumber-1].answer&&questions[currentNumber-1].option[j].select">
                <img src="{{assetsRoute}}/picture/courselearning/wrong.png" alt="" class="optionError"
                     *ngIf="(!questions[currentNumber-1].selectable)&&questions[currentNumber-1].selectedOption != questions[currentNumber-1].answer&&questions[currentNumber-1].option[j].select">
            </div>
        </div>
        <div *ngIf="questions[currentNumber-1].type=='多选题'">
            <img src="{{assetsRoute}}/picture/courselearning/right.png" alt="" class="optionCorrect"
                 *ngIf="(!questions[currentNumber-1].selectable)&&questions[currentNumber-1].selectedOption == questions[currentNumber-1].answer">
            <img src="{{assetsRoute}}/picture/courselearning/wrong.png" alt="" class="optionError"
                 *ngIf="(!questions[currentNumber-1].selectable)&&questions[currentNumber-1].selectedOption != questions[currentNumber-1].answer">
        </div>
    </div>
    <div class="longModeQuestionBtn fontSize18" (click)="onLongModeBtnClick()"
         [ngClass]="{'longModeQuestionBtnDisable':!questions[currentNumber-1].selected,'longModeQuestionBtnNextLesson':!questions[currentNumber-1].selectable&&completed}">
        <span *ngIf="questions[currentNumber-1].selectable&&!completed">提交</span>
        <span *ngIf="!questions[currentNumber-1].selectable&&currentNumber<questions.length&&!completed">下一题</span>
        <span *ngIf="!questions[currentNumber-1].selectable&&completed&&questionsGroup.length-1==questionIndex">
            下一课 ： {{course.lessons[lessonIndex+1].name}}
        </span>
        <span *ngIf="!questions[currentNumber-1].selectable&&completed&&questionsGroup.length-1>questionIndex">
            下一练习 ： 课后练习{{questionIndex+2}}
        </span>
        <span *ngIf="!questions[currentNumber-1].selectable&&currentNumber==questions.length&&!completed">有题目未完成</span>
    </div>
</div> -->

<div id="questionNumberListWrap" *ngIf="questionsGroup&&mode == 2">
    <div class="questionNumberListHead fontSize16 lineHeight21" (click)="onQuestionNumberListHeadClick()">
        <span class="questionNumberListInnerText">题目<br/>列表</span>
    </div>
    <div class="questionNumberListNumber fontSize18" id="questionNumberListNumber{{i}}"
         *ngFor="let item of questions;let i=index"
         (click)="onQuestionNumberListNumberClick(i)">
        <span class="questionNumberListInnerText">{{i+1}}</span>
    </div>
</div>

<div id="analysis" *ngIf="questionsGroup&&mode == 2">
    <div id="analysisHead"
      [ngClass]="{'analysisHeadSuccess':questions[currentNumber-1].selectedOption == questions[currentNumber-1].answer,'analysisHeadError':questions[currentNumber-1].selectedOption != questions[currentNumber-1].answer}">
        <img src="{{assetsRoute}}/picture/courselearning/smile.png" alt="" class="successImage2"
             *ngIf="questions[currentNumber-1].selectedOption == questions[currentNumber-1].answer">
        <img src="{{assetsRoute}}/picture/courselearning/cry.png" alt="" class="successImage2"
             *ngIf="questions[currentNumber-1].selectedOption != questions[currentNumber-1].answer">
        <div id="analysisHeadText" class="fontSize19">
            <span *ngIf="questions[currentNumber-1].selectedOption == questions[currentNumber-1].answer">
                Bingo,你答对了！
            </span>
            <span *ngIf="questions[currentNumber-1].selectedOption != questions[currentNumber-1].answer">
                别灰心，继续努力！
            </span>
        </div>
    </div>
    <div id="analysisContent" class="fontSize16 lineHeight24"
         [ngClass]="{'analysisContentSuccess':questions[currentNumber-1].selectedOption == questions[currentNumber-1].answer,'analysisContentError':questions[currentNumber-1].selectedOption != questions[currentNumber-1].answer}">
        【答案解析】{{questions[currentNumber-1].analysis}}
    </div>
</div>

<div id="shade"></div>

<div id="shade2">
    <img src="{{assetsRoute}}/picture/courselearning/notice.png" alt="" id="slideTipPic1">
    <div id="slideTipText" class="fontSize24">左右滑动卡片可切换卡片</div>
    <div id="slideTipButton" class="fontSize18" (click)="slideTipOut()">朕知道了</div>
</div>

<div id="tip1" class="tip">
  <p class="fontSize16 lineHeight21">你还没有完成练习，确定要退出么？</p>

  <button id="quitBtn" class="btnWord" (click)="exit();">退出</button>
  <button id="continueBtn" class="btnWord" (click)="continue();">继续做题</button>
</div>

<div id="shade3">
  <div id="slideTipText2" class="fontSize24">点击<span id="slideTipText3" class="fontSize28">查看答案</span>后才能进入下一题</div>
</div>



// WEBPACK FOOTER //
// ./src/app/course-learning-question/course-learning-question.component.html